import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconTriangleDownArrow(props: SvgIconProps) {
  return (
    <SVGIcon
      width="16"
      height="16"
      version="1.1"
      viewBox="0 0 4.2333 4.2333"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m0.52917 0.97014 1.5875 2.1167 1.5875-2.1167z" stroke="currentColor" strokeWidth=".26458px" />
    </SVGIcon>
  );
}
